import { memo } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { useOrganizationStore } from "stores/OrganizationStore";

// -----------------------------------------------------------------------------

const EnvironmentPossibleDestination = memo(
  function EnvironmentPossibleDestination({
    destination: { label, coverImage: CoverImage, onConnect } = {} as any,
    hideDismissButton,
  }: EnvironmentPossibleDestinationProps): JSX.Element {
    const [organizationStore] = useOrganizationStore();
    const navigate = useNavigate();

    //
    return (
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <Card elevation={1} sx={{ maxHeight: 192, position: "relative" }}>
          <Box
            sx={{
              paddingTop: `${100 * (10 / 16)}%`,
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                bottom: 0,
                left: 0,
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  flexGrow: 1,
                  padding: 4,
                }}
              >
                <CoverImage
                  alt={label}
                  sx={{
                    flexGrow: 1,
                    width: "100%",
                  }}
                />
              </Box>
              <Stack
                direction="row"
                sx={{
                  borderTop: "1px rgba(0, 0, 0, 0.1) solid",
                  flexShrink: 0,
                  p: 1,
                }}
              >
                {hideDismissButton ? null : <Button>Dismiss</Button>}
                <Box sx={{ flexGrow: 1 }} />
                <Button
                  variant="contained"
                  onClick={() => onConnect?.(organizationStore, navigate)}
                >
                  Connect
                </Button>
              </Stack>
            </Box>
          </Box>
        </Card>
      </Grid>
    );
  }
);

export default EnvironmentPossibleDestination;

// -----------------------------------------------------------------------------

interface EnvironmentPossibleDestinationProps {
  destination: {
    name: string;
    label: string;
    coverImage: Function;
    onConnect: Function;
  };
  hideDismissButton?: boolean;
}
